/* eslint-disable */
require('./terminal')
